import React, { useEffect, useCallback, useState } from 'react';
import { ShakkerTour } from '@shakkerai/pro-components';
import { Icon } from '@shakkerai/components';
import { translate } from '@shakkerai/util-i18n';
import { useTempState, setTempState } from '@starflow/app/store';

export const GuideWrapper = React.memo(({ userInfo }) => {
  const guideTipOpen = useTempState('newerGuideTipOpen');
  const [guideTipSteps, setGuideTipSteps] = useState([]);

  useEffect(() => {
    if (userInfo) {
      const steps = [
        {
          title: translate('guideTip_prompt_title'),
          description: translate('guideTip_prompt_desc'),
          placement: 'bottom',
          target: () => {
            const target = document.getElementById('primaryPromptWrapper');
            return target;
          },
          nextButtonProps: {
            children: translate('tip_next'),
          },
          prevButtonProps: {
            children: translate('tip_prev'),
          },
        },
        {
          title: translate('guideTip_checkpoint_title'),
          description: translate('guideTip_checkpoint_desc'),
          placement: 'left',
          target: () => document.getElementById('checkpointModelEntry'),
          nextButtonProps: {
            children: translate('tip_next'),
          },
          prevButtonProps: {
            children: translate('tip_prev'),
          },
        },
        {
          title: translate('guideTip_lora_title'),
          description: translate('guideTip_lora_desc'),
          placement: 'left',
          target: () => document.getElementById('loraModelEntry'),
          nextButtonProps: {
            children: translate('tip_next'),
          },
          prevButtonProps: {
            children: translate('tip_prev'),
          },
        },
        {
          title: translate('guideTip_img2img_title'),
          description: translate('guideTip_img2img_desc'),
          placement: 'top',
          target: () => document.getElementById('img2imgButtonEntry'),
          nextButtonProps: {
            children: translate('tip_next'),
          },
          prevButtonProps: {
            children: translate('tip_prev'),
          },
        },
        // {
        //   title: translate('guideTip_imgreferrer_title'),
        //   description: translate('guideTip_imgreferrer_desc'),
        //   placement: 'left',
        //   target: () => document.getElementById('imgReferrerEntry'),
        //   nextButtonProps: {
        //     children: translate('tip_next'),
        //   },
        //   prevButtonProps: {
        //     children: translate('tip_prev'),
        //   },
        // },
        {
          title: translate('guideTip_mode_title'),
          description: translate('guideTip_mode_desc'),
          placement: 'topLeft',
          target: () => document.getElementById('modeSwitchBtn'),
          nextButtonProps: {
            children: translate('tip_next'),
          },
          prevButtonProps: {
            children: translate('tip_prev'),
          },
        },
        {
          title: translate('guideTip_finish_title'),
          // description: (
          //   <span className="flex items-center">
          //     {translate('guideTip_finish_desc_1')}
          //     <Icon className="icon-problem text-primary" fontSize={20} />
          //     {translate('guideTip_finish_desc_2')}
          //   </span>
          // ),
          description: translate('Landing_restart_title'),
          placement: 'bottom',
          target: () => document.getElementById('helpButtonEntry'),
          nextButtonProps: {
            children: translate('tip_done'),
          },
          prevButtonProps: {
            children: translate('tip_prev'),
          },
        },
      ];

      const target = document.getElementById('primaryPromptWrapper');
      if (target) {
        setGuideTipSteps(steps);
      } else {
        setTimeout(() => {
          setGuideTipSteps(steps);
        }, 600);
      }
    }
  }, [userInfo]);

  const handleCloseGuide = useCallback(() => {
    setTempState({ newerGuideTipOpen: false });
  }, []);

  useEffect(() => {
    // 如果是从社区运行模型跳过来的
    const search = new URLSearchParams(location.search);
    // 运行模型
    const modelUuid = search.get('model');
    const modelVersionUuid = search.get('version');
    // 生图
    const imageGroupUuid = search.get('group');
    const imageUuid = search.get('image');
    // remix
    const generateId = search.get('generateId');
    const imageId = search.get('imageId');

    let from = '';

    if (modelUuid && modelVersionUuid) {
      from = 'runModel';
    } else if (imageGroupUuid && imageUuid) {
      from = 'generate';
    } else if (generateId && imageId) {
      from = 'remix';
    }

    setTempState({ from: from });

    if (!from) {
      const localFlag = localStorage.getItem('__FIRST_ENTER_FLAG__');

      if (localFlag !== '1' && userInfo) {
        setTempState({ newerGuideTipOpen: true });
        localStorage.setItem('__FIRST_ENTER_FLAG__', '1');
      }
    }
  }, [userInfo]);

  console.log('guideTipOpen', guideTipOpen);

  return <ShakkerTour open={!!guideTipOpen} steps={guideTipSteps} onClose={handleCloseGuide} />;
});
